import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'commaSeprated'
})
export class CommaSepratedPipe implements PipeTransform {
  // transform(value: unknown, ...args: unknown[]): unknown {
  //   return null;
  // }
  public stringData;
 titleData = []
  str: string;
  transform(val:string) {
  //  this.titleData.push(val)
///
    let data = val + ',';
    let chrAtt = val.charAt(-(val.length-1));
    
  //let str = data.endsWith(',') ? Array.from(data).splice(0,data.length - 1).join('') : data;
    return data;
    //return val + ','
  }
}
